import { GlobalFilterObject } from '@type/filters';
import { ISearchFiltersObject } from './searchFiltersObject';

export const mapSearchFilterToGlobalFilter: (filter: ISearchFiltersObject, groupType: string) => GlobalFilterObject = (filter, groupType) => ({
  groupType,
  apiParameter: filter.apiParameter,
  fields: filter.fields.map((field) => ({
    recordOptions: {
      ...field,
    },
    label: field.filtersLabel,
  })),
});
